<h2 mat-dialog-title>{{ isEdit ? 'Edit Rider' : 'New Rider' }}</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
    <mat-form-field appearance="fill">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="fullName" required />
        <mat-error *ngIf="form.get('fullName')?.invalid && form.get('fullName')?.touched">
          Full name is required
        </mat-error>
    </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Phone Number</mat-label>
    <input matInput formControlName="phoneNumber" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Map to User</mat-label>
    <mat-select formControlName="userId">
      <mat-option value="">None</mat-option>
      <mat-option *ngFor="let u of users" [value]="u.id">{{ u.email }} ({{ u.fullName || u.userName }})</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Map to Staff</mat-label>
    <mat-select formControlName="staffId">
      <mat-option [value]="null">None</mat-option>
      <mat-option *ngFor="let s of staff" [value]="s.id">{{ s.fullName }} ({{ s.position || '–' }})</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Email</mat-label>
    <input matInput formControlName="email" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Address</mat-label>
    <textarea matInput formControlName="address"></textarea>
  </mat-form-field>

  <h3>Guarantor Details</h3>

  <mat-form-field appearance="fill">
    <mat-label>Guarantor Name</mat-label>
    <input matInput formControlName="guarantorName" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Guarantor Phone</mat-label>
    <input matInput formControlName="guarantorPhone" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Guarantor Address</mat-label>
    <textarea matInput formControlName="guarantorAddress"></textarea>
  </mat-form-field>

  <h3>Assigned Work Phone</h3>

  <mat-form-field appearance="fill">
    <mat-label>Phone Model</mat-label>
    <input matInput formControlName="assignedPhoneModel" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Phone IMEI</mat-label>
    <input matInput formControlName="assignedPhoneImei" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Phone Number</mat-label>
    <input matInput formControlName="assignedPhoneNumber" />
  </mat-form-field>

  <mat-slide-toggle formControlName="isActive">Active</mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">
    {{ isEdit ? 'Update' : 'Save' }}
  </button>
</mat-dialog-actions>
